import { Illu } from "./Illustrations";

export const Process = ({ texts, steps }) => (
  <section id="ablauf" data-testid="process-section" className="relative border-b border-paper-line ap-section">
    <div className="ap-container">
      <div className="max-w-3xl">
        <p className="ap-stamp mb-4">AP · ABLAUF</p>
        <h2 className="ap-h2 text-ink">{texts.process_h2}</h2>
        <p className="ap-lead mt-5">{texts.process_intro}</p>
      </div>

      <div className="relative mt-12">
        {/* connecting construction line across the four steps (desktop only) */}
        <div className="pointer-events-none absolute inset-x-0 top-[92px] hidden lg:block" aria-hidden="true">
          <span className="block h-px w-full bg-ink/15" />
          {[12.5, 37.5, 62.5, 87.5].map((left) => (
            <span
              key={left}
              className="absolute -top-[3px] h-1.5 w-1.5 bg-signal"
              style={{ left: `${left}%` }}
            />
          ))}
        </div>

        <ol className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4 lg:gap-5">
          {steps.map((s, i) => {
            const illu = [texts.illu_process_1, texts.illu_process_2, texts.illu_process_3, texts.illu_process_4][i];
            const fallback = ["document", "response", "mapping", "calendar"][i] || "document";
            return (
              <li
                key={s.id}
                data-testid={`process-step-${i}`}
                className={`relative animate-rise ${i % 2 === 1 ? "lg:mt-10" : ""}`}
                style={{ animationDelay: `${i * 70}ms` }}
              >
                <div className="relative">
                  <span className="absolute -left-1 top-0 font-display text-5xl font-black leading-none text-ink/10">
                    0{i + 1}
                  </span>
                  <div className="ap-illu relative ml-6 h-24 w-24 sm:h-28 sm:w-28">
                    <Illu name={illu} fallback={fallback} className="h-full w-full" />
                  </div>
                </div>
                <div className="mt-4 border-t border-paper-line pt-4">
                  <h3 className="font-display text-lg font-bold uppercase tracking-wide text-ink">{s.title}</h3>
                  <p className="ap-body mt-2 text-charcoal">{s.body}</p>
                </div>
              </li>
            );
          })}
        </ol>
      </div>

      <p className="ap-stamp mt-10">Kein öffentlich buchbarer Kalender · keine automatische Projektannahme</p>
    </div>
  </section>
);
